const matchupReducer = (state = {}, action) => {
    const { type = null, datasource, data = {} } = action;
    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const { liveData = {}, gameData = {} } = data;
        return {
            ...state,
            liveData,
            gameData
        };
    }
    if (type === 'dataEngine_update_response' && datasource === 'ruleSettings') {
        const { ruleSettings } = data;
        const tiebreakerScenario = ruleSettings?.find(rule => rule?.settingId === 38 && rule?.settingName === 'tiebreakerScenario');
        return {
            ...state,
            tiebreakerScenario
        };
    }

    return state;
};

export default matchupReducer;
